import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, MapPin, Calendar, ArrowRight, Package } from 'lucide-react';
import { Button } from '../components/ui/button';

const ThankYouPage = () => {
  return (
    <div className="min-h-screen bg-white pt-24" data-testid="thank-you-page">
      <div className="px-6 md:px-12 py-12">
        <div className="max-w-3xl mx-auto">
          {/* Success Header */}
          <div className="text-center mb-12">
            <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-12 h-12 text-green-600" />
            </div>
            <h1 className="font-['Barlow_Condensed'] text-4xl md:text-5xl font-bold uppercase tracking-tight mb-4" style={{ color: '#333333' }}>
              Thank You!
            </h1>
            <p className="text-lg" style={{ color: '#666666' }}>
              Your rental order has been submitted. Complete payment on Shopify to confirm your booking.
            </p>
          </div>

          {/* What's Next */}
          <div className="bg-gray-50 border border-gray-200 p-6 mb-8">
            <h2 className="font-['Barlow_Condensed'] text-xl font-semibold uppercase tracking-tight mb-4 flex items-center gap-2" style={{ color: '#333333' }}>
              <Package className="w-5 h-5 text-[#C6A87C]" />
              What Happens Next?
            </h2>

            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-[#C6A87C] text-black font-bold flex items-center justify-center flex-shrink-0">1</div>
                <div>
                  <p className="font-semibold" style={{ color: '#333333' }}>Complete Payment</p>
                  <p className="text-sm" style={{ color: '#666666' }}>
                    You should have been redirected to Shopify's secure checkout. If not, check your email for the invoice link.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-[#C6A87C] text-black font-bold flex items-center justify-center flex-shrink-0">2</div>
                <div>
                  <p className="font-semibold" style={{ color: '#333333' }}>Order Confirmation</p>
                  <p className="text-sm" style={{ color: '#666666' }}>
                    You'll receive an email with your order details and rental information.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-[#C6A87C] text-black font-bold flex items-center justify-center flex-shrink-0">3</div>
                <div>
                  <p className="font-semibold" style={{ color: '#333333' }}>Gear Preparation & Shipping</p>
                  <p className="text-sm" style={{ color: '#666666' }}>
                    Our team will professionally sanitize and ship your gear to your specified address before your rental start date.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-[#C6A87C] text-black font-bold flex items-center justify-center flex-shrink-0">4</div>
                <div>
                  <p className="font-semibold" style={{ color: '#333333' }}>Enjoy Your Ride!</p>
                  <p className="text-sm" style={{ color: '#666666' }}>
                    Hit the road with premium protection. Return gear by the date specified in your confirmation.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Deposit Note */}
          <div className="bg-amber-50 border border-amber-200 p-4 mb-8 text-sm flex items-start gap-3" data-testid="deposit-note">
            <Calendar className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-semibold text-amber-700">Security Deposit</p>
              <p style={{ color: '#666666' }}>
                Your $150 refundable security deposit will be returned after your gear is inspected upon return. Track your deposit status on your dashboard.
              </p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/dashboard" className="flex-1">
              <Button
                className="w-full bg-[#1a1a1a] text-white hover:bg-[#333] font-bold uppercase tracking-wider h-14"
                data-testid="view-orders-btn"
              >
                View My Orders
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
            <Link to="/products" className="flex-1">
              <Button
                variant="outline"
                className="w-full border-gray-200 hover:border-[#C6A87C] hover:text-[#C6A87C] font-bold uppercase tracking-wider h-14"
                style={{ color: '#333333' }}
                data-testid="browse-more-btn"
              >
                Browse More Gear
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
